import React, {useState, useEffect} from "react";


import Contact from '../containers/navigation/Contact';
import DownloadResume from '../containers/navigation/DownloadResume';
import Linkedin from '../containers/navigation/Linkedin';

import Grid from '@material-ui/core/Grid';

import '../Navigation.css'

import posed from 'react-pose';

const NavContainer = posed.div({
    open: {
        x: '0%',
        delayChildren: 1000,
        staggerChildren: 200
    },
    closed: {x: '200%', delay: 1000},
    initialPose: 'closed'
});

const Icon = posed.div({
    open: {y: 0, opacity: 1},
    closed: {y: -100, opacity: 0}
});


export default function Navigation() {

    const [open, setOpen] = useState(false);


    useEffect(() => {
        setTimeout(setOpen(true), 1000);
    });

    return (
        <NavContainer pose={open ? 'open' : 'closed'}>
            <Grid
                container
                direction="row"
                justify="space-around"
                alignItems="center"
            >
                <Grid item className="nav-item">
                    <Icon>
                        <DownloadResume></DownloadResume>
                    </Icon>
                </Grid>
                <Grid item className="nav-item">
                    <Icon>
                        <Linkedin></Linkedin>
                    </Icon>
                </Grid>
                <Grid item className="nav-item">
                    <Icon>
                        <Contact></Contact>
                    </Icon>
                </Grid>
            </Grid>
        </NavContainer>
    );
}


// WEBPACK FOOTER //
// ./src/components/Navigation.jsx